import { render } from "./SocialShare.vue?vue&type=template&id=cd9fe1bc&ts=true"
import script from "./SocialShare.vue?vue&type=script&lang=ts"
export * from "./SocialShare.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__